<div class="dialogContent calcHeight content">
    <irb-settings-dialog-banner 
        [showUnsavedChangesWarning]="showUnsavedChangesWarning" 
        [isModified]="isModified"
        [validationErrorTemplates]="validationErrorTemplates"
        [showExpandControls]="false"
        (save)="save()">Announcements
        <span buttonsInEnd><button class="btn-medium-primary btn-spacer" id="createBtn" (click)="create()">Create</button></span>
    </irb-settings-dialog-banner>
    <div class="body">        
        <irb-inventory-grid
            [style.width] = "'100%'"
            [style.height] = "'calc(100vh - 260px)'"
            [showSideBar] = "false"
            [gridOptions] = "gridOptions"
            [footerContent] = "footerContent"
            [frameworkComponents] = 'frameworkComponents'
            (gridReady) = "onGridReady($event)"></irb-inventory-grid>
    </div>
  </div>
  
